const env = import.meta.env.MODE

export const isDevelopment = env === 'development'
export const isPreview = env === 'preview'
export const isStaging = env === 'staging'
export const isProduction = env === 'production'

// The publicdata service is not deployed in the production_us cluster, so any feature that
// depends on it (subprocessor analysis, misclassification, etc.) must be gated on this flag.
export const hasPublicDataService = isDevelopment || isPreview || isStaging || isProduction
